<template>
  <div class="container">
    <a-form-model
      style="margin-top: 3%"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 12 }"
      :model="form"
      :rules="rules"
      ref="ruleForm"
    >
      <a-form-model-item label="产品型号标识" prop="identifier">
        <a-input disabled v-model="form.identifier" placeholder="请输入产品型号标识" />
      </a-form-model-item>
      <a-form-model-item label="产品型号名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入产品型号名称" />
      </a-form-model-item>
      <a-form-model-item label="关联产品小类" prop="productSubClassId">
        <a-select v-model="form.productSubClassId" show-search optionFilterProp="label" allowClear>
          <a-select-option v-for="filter in productSubClasses" :key="filter.id" :value="filter.id" :label="filter.name">
            {{ filter.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>
      <a-form-model-item label="" :wrapper-col="{ offset: 5, span: 12 }">
        <div style="margin-top: 3%">
          <a-button type="primary" @click="handleSubmit"> 保存 </a-button>
          <a-button style="margin-left: 3%" @click="goBack">返回</a-button>
        </div>
      </a-form-model-item>
      <!-- <a-form-model-item label="关联物模型">
        <a-button @click="handleAddBtn">添加</a-button>
        <a-table rowKey="productId" :data-source="form.productDtos" size="small">
          <a-table-column align="center" data-index="productId" key="productId" title="产品ID"></a-table-column>
          <a-table-column align="center" data-index="name" key="name" title="产品名称"></a-table-column>
          <a-table-column align="center" data-index="type" key="type" title="产品类型">
            <template slot-scope="scope"> {{ productTypes(scope) }}</template>
          </a-table-column>
          <a-table-column align="center" title="操作" data-index="operation" key="operation">
            <template slot-scope="text, record">
              <a-button @click="jumpToDetail(record)" type="link" style="color: #70b603">详情</a-button>
              <a-button @click="handleDeleteProduct(record)" type="link" style="color: #d9001b">删除</a-button>
            </template>
          </a-table-column>
        </a-table>
        <div style="margin-top: 3%">
          <a-button type="primary" @click="handleSubmit"> 保存 </a-button>
          <a-button style="margin-left: 3%" @click="goBack">返回</a-button>
        </div>
      </a-form-model-item> -->
    </a-form-model>
    <ProductTransferModal ref="productTransferModal" @selectedProduct="handleSelectedProduct" />
  </div>
</template>
<script>
import ProductTransferModal from './components/ProductTransferModal';

export default {
  name: 'ProductModelCreator',
  components: { ProductTransferModal },
  async activated() {
    await this.getProductModel();
    this.getProductSubClasses();
  },
  data() {
    return {
      form: {
        identifier: '',
        name: '',
        productDtos: [],
        remark: '',
        productSubClassId: null,
      },
      productSubClasses: [],
      metaData: this.$store.state.metaData,
      rules: {
        identifier: [{ required: true, message: '请输入产品型号标识', trigger: 'blur' }],
        name: [{ required: true, message: '请输入产品型号名称', trigger: 'blur' }],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$apiManager.productModel
            .updateProductService({
              ...this.form,
              // productIds: this.form.productDtos.map((product) => product.productId),
            })
            .then(() => {
              this.$message.success('修改成功');
              this.goBack();
            });
        }
      });
    },
    handleAddBtn() {
      this.$refs.productTransferModal.openModal(this.metaData, this.form.productDtos);
    },
    handleSelectedProduct(products) {
      this.form.productDtos = products;
    },
    handleDeleteProduct(product) {
      this.form.productDtos = this.form.productDtos.filter((p) => p.productId !== product.productId);
    },
    jumpToDetail(product) {
      this.$router.push({ name: 'productDetail', params: { id: product.productId } });
    },
    goBack() {
      this.$router.back();
    },
    getProductModel() {
      this.$apiManager.productModel.getProductModelById(this.$route.params.id).then((res) => {
        this.form = res.data;
      });
    },
    getProductSubClasses() {
      this.$apiManager.productSubClass.getProductSubClasses({ unpaged: true }).then((res) => {
        window.console.log(res.data);
        this.productSubClasses = res.data.elements || [];
      });
    },
  },
  computed: {
    productTypes() {
      return (type) => {
        const typeName = this.metaData.productTypes.find((md) => md.value === type);
        return typeName ? typeName.name : '';
      };
    },
  },
};
</script>
<style lang="less" scoped></style>
